import { render } from "./NormasLegalesComponent.vue?vue&type=template&id=3844aa1c"
import script from "./NormasLegalesComponent.vue?vue&type=script&lang=js"
export * from "./NormasLegalesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__